const LocationPermission = (locPer = true, action) => {
  switch (action.type) {
    case "LOC_PER":
      return action.playload;
    default:
      return locPer;
  }
};
export default LocationPermission;
